// extracted by mini-css-extract-plugin
export default {"button":"button__TEQZf","primary":"primary__xD89D","plain":"plain__R5uOs","compact":"compact__2ZT-3"};